<template>
  <div class="planos-wrapper">
    <div class="table-container">
      <div class="table-scroll">
        <table class="planos-table">
          <thead>
            <!-- Primera fila: "Revisión N°X" por sección + columnas fijas (rowspan 3) -->
            <tr class="header-row-title">
              <th class="col-num fixed-col" rowspan="3">N°</th>
              <th class="col-doc fixed-col" rowspan="3">Documento</th>
              <th class="col-esp fixed-col" rowspan="3">Especialidad</th>
              <th class="col-desc fixed-col" rowspan="3">Descripción</th>
              <th class="col-fecha fixed-col" rowspan="3">Fecha</th>
              <th class="col-ver fixed-col" rowspan="3">Ver.</th>
              <th class="col-action fixed-col" rowspan="3"></th>
              <template v-if="hasRevisions">
                <th
                  v-for="i in maxRevisions"
                  :key="`rev-title-${i}`"
                  class="col-rev-title rev-block-start"
                  colspan="4"
                >Revisión N°{{ i }}</th>
              </template>
            </tr>
            <!-- Segunda fila: campos de cada sección de revisión + grupo Entrega -->
            <tr class="header-row-group">
              <template v-if="hasRevisions">
                <template v-for="i in maxRevisions">
                  <th :key="`rev-fecha-${i}`" class="col-rev-field rev-block-start" rowspan="2">Fecha Viñeta</th>
                  <th :key="`rev-entrega-obra-${i}`" class="col-rev-field" rowspan="2">Entrega Obra</th>
                  <th :key="`rev-version-${i}`" class="col-rev-field-sm" rowspan="2">Versión</th>
                  <th :key="`rev-created-${i}`" class="col-rev-field date-created-revision" rowspan="2">Fecha</th>
                </template>
              </template>
            </tr>
          </thead>
          <tbody>
            <template v-for="folder in visibleFolders">
              <!-- Specialty group header -->
              <tr :key="`folder-${folder.id}`" class="group-header">
                <td :colspan="7" class="group-title">
                  <v-icon small class="mr-1" @click="toggleFolder(folder.id)" style="cursor:pointer">
                    {{ expandedFolders[folder.id] ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                  </v-icon>
                  <span class="group-num">{{ getFolderIndex(folder) + 1 }}.0</span>
                  <span class="group-name">{{ folder.name.toUpperCase() }}</span>
                </td>
                <td :colspan="hasRevisions ? 7 + maxRevisions * 9 : 7" class="group-spacer"></td>
              </tr>

              <template v-if="expandedFolders[folder.id]">
                <!-- Subfolders -->
                <template v-for="child in folder.childs.filter(c => !c.name.toLowerCase().includes('obsoleto'))">
                  <tr :key="`child-${child.id}`" class="subgroup-header">
                    <td :colspan="7" class="subgroup-title">
                      <v-icon small class="mr-1" @click="toggleFolder(`child-${child.id}`)" style="cursor:pointer">
                        {{ expandedFolders[`child-${child.id}`] ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                      </v-icon>
                      <span class="subgroup-num">{{ getFolderIndex(folder) + 1 }}.{{ getChildIndex(folder, child) + 1 }}</span>
                      <span class="subgroup-name">{{ child.name.toUpperCase() }}</span>
                    </td>
                    <td :colspan="hasRevisions ? 7 + maxRevisions * 9 : 7" class="subgroup-spacer"></td>
                  </tr>

                  <template v-if="expandedFolders[`child-${child.id}`]">
                    <tr
                      v-for="(file, fi) in child.files"
                      :key="`child-file-${file.id}`"
                      class="file-row"
                      :class="{ 'row-even': fi % 2 === 0 }"
                    >
                      <td class="col-num td-center fixed-col">{{ getGlobalFileIndex(folder, child, fi) + 1 }}</td>
                      <td class="col-doc td-mono fixed-col">{{ file.name.split(' - ')[1] || file.name }}</td>
                      <td class="col-esp td-center fixed-col"><span class="specialty-tag">{{ folder.name }}</span></td>
                      <td class="col-desc fixed-col">{{ getDescription(file) }}</td>
											<td class="col-fecha td-center fixed-col"><span class="date-label">{{ getRevisionSource(file).created_at | toDate }}</span></td>
                      <td class="col-ver td-center fixed-col">{{ getFileRevisions(file).length > 0 ? getFileRevisions(file)[getFileRevisions(file).length - 1].version || 0 : 0 }}</td>
                      <td class="col-action fixed-col td-center">
                        <button class="add-revision-btn" @click.stop="handleAddRevision(file, child.id)" title="Agregar revisión">
                          <v-icon size="14">mdi-source-branch-plus</v-icon>
                        </button>
                      </td>
                      <template v-if="hasRevisions">
                        <template v-for="ri in maxRevisions">
                          <!-- Fecha Viñeta -->
                          <td :key="`f${file.id}-r${ri}-fecha`" class="col-rev-field editable-cell rev-block-start">
                            <template v-if="getFileRevisions(file)[ri-1]">
                              <v-menu
                                :value="!!dateMenus[`${file.id}-${ri}-fecha`]"
                                @input="$set(dateMenus, `${file.id}-${ri}-fecha`, $event)"
                                :close-on-content-click="false"
                                offset-y
                                min-width="290"
                                transition="scale-transition"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <button class="date-picker-btn" v-bind="attrs" v-on="on">
                                    <v-icon size="13" class="date-icon">mdi-calendar</v-icon>
																		<span class="date-label" v-if="getFileRevisions(file)[ri-1].info_date">
																			{{ getFileRevisions(file)[ri-1].info_date | toDate }}
																		</span>
																		<span class="date-label" v-else>
																			Seleccionar
																		</span>
                                    <v-icon v-if="getFileRevisions(file)[ri-1].info_date" size="11" class="date-clear" @click.stop="updateRevision(file, ri-1, 'info_date', null)">mdi-close</v-icon>
                                  </button>
                                </template>
                                <v-date-picker
                                  :value="toDateInput(getFileRevisions(file)[ri-1].info_date)"
                                  @input="updateRevision(file, ri-1, 'info_date', $event); $set(dateMenus, `${file.id}-${ri}-fecha`, false)"
                                  no-title
                                />
                              </v-menu>
                            </template>
                            <span v-else class="empty-cell">—</span>
                          </td>
                          <!-- Entrega Obra -->
                          <td :key="`f${file.id}-r${ri}-entrega`" class="col-rev-field editable-cell">
                            <template v-if="getFileRevisions(file)[ri-1]">
                              <v-menu
                                :value="!!dateMenus[`${file.id}-${ri}-entrega`]"
                                @input="$set(dateMenus, `${file.id}-${ri}-entrega`, $event)"
                                :close-on-content-click="false"
                                offset-y
                                min-width="290"
                                transition="scale-transition"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <button class="date-picker-btn" v-bind="attrs" v-on="on">
                                    <v-icon size="13" class="date-icon">mdi-calendar</v-icon>
																		<span class="date-label" v-if="getFileRevisions(file)[ri-1].delivery_date">
																			{{ getFileRevisions(file)[ri-1].delivery_date | toDate }}
																		</span>
																		<span class="date-label" v-else>
																			Seleccionar
																		</span>
                                    <v-icon v-if="getFileRevisions(file)[ri-1].delivery_date" size="11" class="date-clear" @click.stop="updateRevision(file, ri-1, 'delivery_date', null)">mdi-close</v-icon>
                                  </button>
                                </template>
                                <v-date-picker
                                  :value="toDateInput(getFileRevisions(file)[ri-1].delivery_date)"
                                  @input="updateRevision(file, ri-1, 'delivery_date', $event); $set(dateMenus, `${file.id}-${ri}-entrega`, false)"
                                  no-title
                                />
                              </v-menu>
                            </template>
                            <span v-else class="empty-cell">—</span>
                          </td>
                          <!-- Versión -->
                          <td :key="`f${file.id}-r${ri}-version`" class="col-rev-field-sm editable-cell">
                            <v-text-field
                              v-if="getFileRevisions(file)[ri-1]"
                              :value="getFileRevisions(file)[ri-1].version || String(ri)"
                              @change="updateRevision(file, ri-1, 'version', $event)"
                              dense hide-details solo flat
                              placeholder="—"
                              class="rev-text-field"
                            />
                            <span v-else class="empty-cell">—</span>
                          </td>
													<!-- Fecha Carga -->
													<td :key="`f${file.id}-r${ri}-fecha`" class="col-rev-field text-center">
														<span class="date-label text-center" v-if="getFileRevisions(file)[ri-1]">
															{{ getFileRevisions(file)[ri-1].created_at | toDate }}
														</span>
													</td>
                        </template>
                      </template>
                    </tr>
                  </template>
                </template>

                <!-- Direct files in folder -->
                <template v-for="(file, fi) in folder.files">
                  <tr
                    :key="`file-${file.id}`"
                    class="file-row"
                    :class="{ 'row-even': fi % 2 === 0 }"
                  >
                    <td class="col-num td-center fixed-col">{{ fi + 1 }}</td>
                    <td class="col-doc td-mono fixed-col">{{ getDocCode(file) }}</td>
                    <td class="col-esp td-center fixed-col"><span class="specialty-tag">{{ folder.name }}</span></td>
                    <td class="col-desc fixed-col">{{ getDescription(file) }}</td>
										<td class="col-fecha td-center fixed-col"><span class="date-label">{{ getRevisionSource(file).created_at | toDate }}</span></td>
                    <td class="col-ver td-center fixed-col">{{ getFileRevisions(file).length > 0 ? getFileRevisions(file)[getFileRevisions(file).length - 1].version || 0 : 0 }}</td>
                    <td class="col-action fixed-col td-center">
                      <button class="add-revision-btn" @click.stop="handleAddRevision(file, folder.id)" title="Agregar revisión">
                        <v-icon size="14">mdi-source-branch-plus</v-icon>
                      </button>
                    </td>
                    <template v-if="hasRevisions">
                      <template v-for="ri in maxRevisions">
                        <!-- Fecha Viñeta -->
                        <td :key="`f${file.id}-r${ri}-fecha`" class="col-rev-field editable-cell rev-block-start">
                          <template v-if="getFileRevisions(file)[ri-1]">
                            <v-menu
                              :value="!!dateMenus[`${file.id}-${ri}-fecha`]"
                              @input="$set(dateMenus, `${file.id}-${ri}-fecha`, $event)"
                              :close-on-content-click="false"
                              offset-y min-width="290"
                              transition="scale-transition"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <button class="date-picker-btn" v-bind="attrs" v-on="on">
                                  <v-icon size="13" class="date-icon">mdi-calendar</v-icon>
                                  <span class="date-label" v-if="getFileRevisions(file)[ri-1].info_date">
                                    {{ getFileRevisions(file)[ri-1].info_date | toDate }}
                                  </span>
                                  <span class="date-label" v-else>
                                    Seleccionar
                                  </span>
                                  <v-icon v-if="getFileRevisions(file)[ri-1].info_date" size="11" class="date-clear" @click.stop="updateRevision(file, ri-1, 'info_date', null)">mdi-close</v-icon>
                                </button>
                              </template>
                              <v-date-picker
                                :value="toDateInput(getFileRevisions(file)[ri-1].info_date)"
                                @input="updateRevision(file, ri-1, 'info_date', $event); $set(dateMenus, `${file.id}-${ri}-fecha`, false)"
                                no-title
                              />
                            </v-menu>
                          </template>
                          <span v-else class="empty-cell">—</span>
                        </td>
                        <!-- Entrega Obra -->
                        <td :key="`f${file.id}-r${ri}-entrega`" class="col-rev-field editable-cell">
                          <template v-if="getFileRevisions(file)[ri-1]">
                            <v-menu
                              :value="!!dateMenus[`${file.id}-${ri}-entrega`]"
                              @input="$set(dateMenus, `${file.id}-${ri}-entrega`, $event)"
                              :close-on-content-click="false"
                              offset-y min-width="290"
                              transition="scale-transition"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <button class="date-picker-btn" v-bind="attrs" v-on="on">
                                  <v-icon size="13" class="date-icon">mdi-calendar</v-icon>
                                  <span class="date-label" v-if="getFileRevisions(file)[ri-1].delivery_date">
                                    {{ getFileRevisions(file)[ri-1].delivery_date | toDate }}
                                  </span>
                                  <span class="date-label" v-else>
                                    Seleccionar
                                  </span>
                                  <v-icon v-if="getFileRevisions(file)[ri-1].delivery_date" size="11" class="date-clear" @click.stop="updateRevision(file, ri-1, 'delivery_date', null)">mdi-close</v-icon>
                                </button>
                              </template>
                              <v-date-picker
                                :value="toDateInput(getFileRevisions(file)[ri-1].delivery_date)"
                                @input="updateRevision(file, ri-1, 'delivery_date', $event); $set(dateMenus, `${file.id}-${ri}-entrega`, false)"
                                no-title
                              />
                            </v-menu>
                          </template>
                          <span v-else class="empty-cell">—</span>
                        </td>
                          <!-- Versión -->
                            <td :key="`f${file.id}-r${ri}-version`" class="col-rev-field-sm editable-cell">
                          <v-text-field
                            v-if="getFileRevisions(file)[ri-1]"
                            :value="getFileRevisions(file)[ri-1].version || String(ri)"
                            @change="updateRevision(file, ri-1, 'version', $event)"
                            dense hide-details solo flat
                            placeholder="—"
                            class="rev-text-field"
                          />
                          <span v-else class="empty-cell">—</span>
                        </td>
												<!-- Fecha Carga -->
												<td :key="`f${file.id}-r${ri}-fecha`" class="col-rev-field date-created-revision text-center">
													<span class="date-label" v-if="getFileRevisions(file)[ri-1]">
														{{ getFileRevisions(file)[ri-1].created_at | toDate }}
													</span>
												</td>
                      </template>
                    </template>
                  </tr>
                </template>
              </template>
            </template>
          </tbody>
        </table>
      </div>
    </div>

    <FMAddRevision
      v-if="showAddRevisionDialog"
      :item="revisionFileItem"
      @confirm="uploadRevision"
      @cancel="showAddRevisionDialog = false"
    />
  </div>
</template>

<script>
import _debounce from 'lodash/debounce'
import { v4 as uuidv4 } from 'uuid'
import FMAddRevision from '../FileManager/FMAddRevision.vue'
import { setDocumentInfo } from '@/helpers/api/documents'

export default {
  name: 'DocumentsRevisionTable',

  components: { FMAddRevision },

  props: {
    data: {
      type: Object,
      default: () => ({ folders: [] })
    }
  },

  data() {
    return {
      expandedFolders: {},
      localData: null,
      showAddRevisionDialog: false,
      revisionFileItem: null,
      revisionFolderId: null,
      dateMenus: {}
    }
  },

  computed: {
    folders() {
      return this.localData ? this.localData.folders : []
    },

    selectedProject() {
      return this.$store.projectsStore.state.selectedProject
    },

    // Carpetas visibles: se excluyen las que tengan 'obsoleto' en el nombre
    visibleFolders() {
      return this.folders.filter(folder =>
        !folder.name.toLowerCase().includes('obsoleto')
      )
    },

    maxRevisions() {
      let max = 0
      const check = (files) => {
        files.forEach(f => {
          const revs = this.getFileRevisions(f)
          if (revs.length > max) max = revs.length
        })
      }
      this.visibleFolders.forEach(folder => {
        check(folder.files || [])
        ;(folder.childs || []).filter(c => !c.name.toLowerCase().includes('obsoleto')).forEach(child => check(child.files || []))
      })
      return Math.max(max, 1)
    },

    hasRevisions() {
      let total = 0
      const check = (files) => {
        files.forEach(f => { total += this.getFileRevisions(f).length })
      }
      this.visibleFolders.forEach(folder => {
        check(folder.files || [])
        ;(folder.childs || []).filter(c => !c.name.toLowerCase().includes('obsoleto')).forEach(child => check(child.files || []))
      })
      return total > 0
    }
  },

  created() {
    this.localData = JSON.parse(JSON.stringify(this.data))
    this.localData.folders.forEach(folder => {
      this.$set(this.expandedFolders, folder.id, true)
      ;(folder.childs || []).forEach(child => {
        this.$set(this.expandedFolders, `child-${child.id}`, true)
      })
    })
    // Map to hold per-revision debounced saver functions
    this._debouncedSavers = {}
  },

  methods: {
    getFileRevisions(file) {
      if (file.main_file_as_revision) {
        const revs = file.main_file_as_revision.revisions || []
        return revs.map(r => ({ ...r, ...(r.info || {}) }))
      }
      const revs = file.revisions || []
      return revs.map(r => ({ ...r, ...(r.info || {}) }))
    },

    getRevisionSource(file) {
      return file.main_file_as_revision || file
    },

    toggleFolder(id) {
      this.$set(this.expandedFolders, id, !this.expandedFolders[id])
    },

    getFolderIndex(folder) {
      return this.visibleFolders.indexOf(folder)
    },

    getChildIndex(folder, child) {
      return (folder.childs || []).indexOf(child)
    },

    getGlobalFileIndex(folder, child, fi) {
      return fi
    },

    getDocCode(file) {
      const match = file.name.match(/^([A-Z]+ - [\d.]+[A-Z]?)/i)
      return match ? match[1] : file.name.split('.')[0]
    },

    getDescription(file) {
      const parts = file.name.split(' - ')
      if (parts.length >= 3) {
        return parts.slice(2).join(' - ').replace(/\.(dwg|pdf|bak|dwl2?)/i, '')
      }
      if (parts.length === 2) {
        return parts[1].replace(/\.(dwg|pdf|bak|dwl2?)/i, '')
      }
      return file.name.replace(/\.(dwg|pdf|bak|dwl2?)/i, '')
    },

    formatDate(dateStr) {
      if (!dateStr) return '—'
      const d = new Date(dateStr)
      const day = String(d.getDate()).padStart(2, '0')
      const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
      return `${day}/${months[d.getMonth()]}/${String(d.getFullYear()).slice(2)}`
    },

    formatDateDisplay(val) {
      if (!val) return ''
      const isoDateOnly = /^\d{4}-\d{2}-\d{2}$/
      let d
      if (isoDateOnly.test(val)) {
        const parts = val.split('-')
        d = new Date(parts[0], Number(parts[1]) - 1, parts[2])
      } else {
        d = new Date(val)
      }
      if (isNaN(d.getTime())) return val
      const day = String(d.getDate()).padStart(2, '0')
      const months = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic']
      return `${day}/${months[d.getMonth()]}/${String(d.getFullYear()).slice(2)}`
    },

    toDateInput(val) {
      if (!val) return ''
      const isoDateOnly = /^\d{4}-\d{2}-\d{2}$/
      if (isoDateOnly.test(val)) return val
      const d = new Date(val)
      if (isNaN(d.getTime())) return ''
      return d.toISOString().slice(0, 10)
    },

		updateRevision(file, revIndex, field, value) {
			const source = this.getRevisionSource(file)
			if (!source.revisions?.[revIndex]) return

			this.$set(source.revisions[revIndex], field, value)
			this.$emit('revision-updated', { file: source, revIndex, field, value })

			const entregaFields = ['pt', 'sup_a', 'sup_b', 'sup', 'ot']
			if (!entregaFields.includes(field)) {
				const rev = source.revisions[revIndex]
				const merged = { ...(rev.info || {}), ...rev, [field]: value }
				this.scheduleSaveRevision(merged)
			}
		},

    handleAddRevision(file, folderId) {
      this.revisionFileItem = file.main_file_as_revision ? file.main_file_as_revision : file
      this.revisionFolderId = folderId
      this.showAddRevisionDialog = true
    },

    uploadRevision(file) {
      if (!this.revisionFileItem || !file) return

      const fileData = {
        type: 14,
        payload: {
          main_file_revision_id: this.revisionFileItem?.revision_parent?.main_file_id || this.revisionFileItem.id,
          last_revision_file_id: this.revisionFileItem?.revision_parent?.file_id || null,
          project_id: this.selectedProject.id,
          folder_id: this.revisionFolderId
        },
        description: `Revisión de ${this.revisionFileItem.name}`,
        total: file.size,
        uuid: uuidv4(),
        file
      }

      this.$store.globalStore.commit('setFilesToUploadCenter', fileData)
      this.$store.globalStore.dispatch('addMessage', {
        message: 'La revisión se está subiendo',
        title: 'Subiendo revisión',
        created: new Date(),
        type: 'success',
        icon: 'mdi-check-circle',
        color: '#3EBFA3'
      })

      this.showAddRevisionDialog = false
      this.revisionFileItem = null
      this.revisionFolderId = null
    },

    scheduleSaveRevision(revision) {
      if (!revision) return
      const revKey = `${revision.id || revision.files_center_revision_id || 'noid'}`
      if (!this._debouncedSavers[revKey]) {
        this._debouncedSavers[revKey] = _debounce((rev) => {
          this.saveRevisionImmediate(rev)
        }, 800)
      }
      this._debouncedSavers[revKey](revision)
    },

		saveRevisionImmediate(revision) {
			const revId = revision.files_center_revision_id || revision.id
			if (!revId) return

			const payload = {
				files_center_revision_id: revId,
				info_date: revision.info_date ?? null,
				delivery_date: revision.delivery_date ?? null,
				version: revision.version ?? null,
				item_info: revision.item_info ?? null
			}

			setDocumentInfo(payload).catch(() => {})
		},
  }
}
</script>

<style scoped>
.planos-wrapper {
	display: flex;
	flex-grow: 1;
	height: 100%;
  font-size: 13px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
}

.table-container {
  position: relative;
	display: flex;
	flex-grow: 1;
  height: 100%;
  overflow: hidden;
}

.table-scroll {
  overflow: auto;
	display: flex;
	flex-grow: 1;
  height: 100%;
  align-items: flex-start;
}

.table-scroll::-webkit-scrollbar { width: 8px; height: 8px; }
.table-scroll::-webkit-scrollbar-track { background: #f0f0f0; }
.table-scroll::-webkit-scrollbar-thumb { background: #9e9e9e; border-radius: 4px; }
.table-scroll::-webkit-scrollbar-thumb:hover { background: #5E85EF; }

/* ─── Tables ──────────────────────────────────────────── */
.planos-table {
  border-collapse: separate;
  border-spacing: 0;
  white-space: nowrap;
  table-layout: fixed;
  align-self: flex-start;
}

.planos-table th,
.planos-table td {
  border-top: none;
  border-left: none;
  border-right: 1px solid #e8ecf5;
  border-bottom: 1px solid #e8ecf5;
  padding: 0;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ─── Headers ─────────────────────────────────────────── */
.planos-table thead th {
  color: #fff;
  font-weight: 500;
  font-size: 12px;
  text-align: center;
  letter-spacing: 0.3px;
  padding: 0 12px;
  height: 40px;
  position: sticky;
  top: 0;
  border-top: none;
  border-left: none;
  border-right: 1px solid rgba(255,255,255,0.2);
  border-bottom: 1px solid rgba(255,255,255,0.2);
  background-clip: padding-box;
}

.header-row th {
  background: #2D4B95 !important;
  font-weight: 600;
  font-size: 12px;
  top: 0;
  z-index: 3;
}

/* Fixed columns */
.fixed-col {
  position: sticky;
  left: 0;
  background: #ffffff;
  z-index: 1;
  background-clip: padding-box;
}

.col-num.fixed-col  { left: 0; }
.col-doc.fixed-col  { left: 36px; }
.col-esp.fixed-col  { left: 166px; }
.col-desc.fixed-col { left: 256px; }
.col-fecha.fixed-col { left: 516px; }
.col-ver.fixed-col  { left: 588px; }
.col-action.fixed-col {
  left: 640px;
  box-shadow: 2px 0 4px rgba(45,75,149,0.2);
}

.file-row .fixed-col       { background: #ffffff; }
.file-row.row-even .fixed-col { background: #fafafa; }
.file-row:hover .fixed-col { background: #f5f5f5; }

.header-row-group th {
  background: #2D4B95 !important;
  font-weight: 600;
  font-size: 12px;
  top: 34px !important;
  z-index: 3;
}

.header-row-title th {
  background: #1a3470 !important;
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  top: 0 !important;
  height: 34px;
  z-index: 3;
}

.col-rev-title {
  text-align: center;
  border-left: 2px solid rgba(255,255,255,0.25) !important;
}

.col-rev-group {
  background: #5E85EF !important;
  font-weight: 700 !important;
  letter-spacing: 0.5px;
}

.header-row th {
  top: 74px !important;
  z-index: 3;
  height: 34px;
}

.header-row-title .fixed-col,
.header-row-group .fixed-col,
.header-row .fixed-col {
  z-index: 4;
  background: #2D4B95 !important;
}

/* ─── Column widths ───────────────────────────────────── */
.col-num    { width: 36px;  min-width: 36px;  max-width: 36px; }
.col-doc    { width: 130px; min-width: 130px; max-width: 130px; }
.col-esp    { width: 90px;  min-width: 90px;  max-width: 90px; }
.col-desc   { width: 260px; min-width: 260px; max-width: 260px; }
.col-fecha  { width: 72px;  min-width: 72px;  max-width: 72px; }
.col-ver    { width: 52px;  min-width: 52px;  max-width: 52px; }
.col-action { width: 40px;  min-width: 40px;  max-width: 40px; }

.col-rev-field    { width: 110px; min-width: 110px; }
.col-rev-field-sm { width: 46px;  min-width: 46px; max-width: 46px; padding: 0 6px; }

.col-rev-field.date-created-revision{ width: 70px !important; min-width: 70px !important; max-width: 70px !important; padding: 0 4px; }

/* ─── Revision block separator ────────────────────────── */
.rev-block-start {
  border-left: 2px solid #5E85EF !important;
}

/* ─── Group headers ───────────────────────────────────── */
.group-header td {
  background: #2D4B95 !important;
  border-top: none !important;
  border-left: none !important;
  border-right: 1px solid rgba(255,255,255,0.15) !important;
  border-bottom: 1px solid rgba(255,255,255,0.15) !important;
  background-clip: padding-box;
  height: 40px;
  max-height: 40px;
  min-height: 40px;
}

.group-title {
  position: sticky;
  left: 0;
  z-index: 2;
  padding: 10px 12px !important;
  font-weight: 600;
  font-size: 13px;
  color: #ffffff;
  letter-spacing: 0.3px;
  background: #2D4B95 !important;
  border-right: 2px solid rgba(255,255,255,0.3) !important;
  box-shadow: 2px 0 4px rgba(45,75,149,0.3);
}

.group-spacer {
  background: #2D4B95 !important;
  border-top: none !important;
  border-left: none !important;
  border-right: 1px solid rgba(255,255,255,0.15) !important;
  border-bottom: 1px solid rgba(255,255,255,0.15) !important;
}

.group-num {
  display: inline-block;
  background: #5E85EF;
  color: #fff;
  border-radius: 4px;
  padding: 3px 10px;
  margin-right: 10px;
  font-size: 12px;
  font-weight: 600;
}

.group-name { font-weight: 600; }

.subgroup-header td {
  background: #f4f6fb !important;
  border-top: none !important;
  border-left: none !important;
  border-right: 1px solid #e8ecf5 !important;
  border-bottom: 1px solid #e8ecf5 !important;
  background-clip: padding-box;
  height: 36px;
}

.subgroup-title {
  position: sticky;
  left: 0;
  z-index: 2;
  padding: 8px 12px 8px 28px !important;
  font-weight: 500;
  font-size: 12px;
  color: #2D4B95;
  background: #f4f6fb !important;
  border-right: 2px solid #cbd5e8 !important;
  box-shadow: 2px 0 4px rgba(45,75,149,0.15);
}

.subgroup-spacer {
  background: #f4f6fb !important;
  border-top: none !important;
  border-left: none !important;
  border-right: 1px solid #e8ecf5 !important;
  border-bottom: 1px solid #e8ecf5 !important;
}

.subgroup-num {
  display: inline-block;
  background: #5E85EF;
  color: #fff;
  border-radius: 4px;
  padding: 3px 8px;
  margin-right: 10px;
  font-size: 11px;
  font-weight: 600;
}

.subgroup-name { font-weight: 500; }

/* ─── File rows ───────────────────────────────────────── */
.file-row td {
  height: 36px;
  background: #ffffff;
  font-size: 13px;
  color: #424242;
  transition: background 0.2s ease;
}

.file-row.row-even td { background: #fafafa; }
.file-row:hover td { background: #f5f5f5 !important; cursor: pointer; }

/* ─── Cell styles ─────────────────────────────────────── */
.td-center { text-align: center; }
.td-mono {
  font-size: 11px;
  padding: 8px !important;
  color: #2D4B95;
  font-weight: 500;
}

.specialty-tag {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #2D4B95;
  background: #e8ecf5;
  padding: 4px 10px;
  border-radius: 4px;
  display: inline-block;
}

.col-desc {
  padding: 8px 12px !important;
  color: #576080;
  font-size: 12px;
}
.col-fecha, .col-ver {
  padding: 8px;
  text-align: center;
  font-size: 11px;
  color: #576080;
}

/* ─── Editable cells ──────────────────────────────────── */
.editable-cell {
  padding: 0 !important;
  position: relative;
}

/* ─── Date picker button ──────────────────────────────── */
.date-picker-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  width: calc(100% - 8px);
  height: 28px;
  margin: 4px;
  padding: 0 7px;
  background: #f7f8fc;
  border: 1px solid #d5dbed;
  border-radius: 5px;
  cursor: pointer;
  color: #424242;
  font-size: 11px;
  font-family: 'Roboto', sans-serif;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
  text-align: left;
  position: relative;
}

.date-picker-btn:hover {
  background: #eef1fa;
  border-color: #5E85EF;
  box-shadow: 0 0 0 2px rgba(94,133,239,0.1);
}

.date-picker-btn:hover .date-icon {
  color: #5E85EF;
}

.date-icon {
  color: #5E85EF;
  flex-shrink: 0;
  transition: color 0.15s ease;
}

.date-label {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11px;
  line-height: 1;
}

/* Muted style when showing placeholder */
.date-picker-btn:not(:has(.date-clear)) .date-label {
  color: #5E85EF;
  font-style: italic;
}

.date-picker-btn:has(.date-clear) .date-label {
  color: #18243d;
  font-weight: 500;
}

.date-clear {
  flex-shrink: 0;
  color: #b0bcd4 !important;
  border-radius: 50%;
  padding: 1px;
  transition: all 0.15s ease;
  opacity: 0;
}

.date-picker-btn:hover .date-clear {
  opacity: 1;
}

.date-clear:hover {
  background: #e8ecf5;
  color: #5E85EF !important;
}

/* ─── Check button (entrega columns) ─────────────────── */
.check-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  margin: auto;
  border: 1.5px solid #d5dbed;
  border-radius: 5px;
  background: #f7f8fc;
  cursor: pointer;
  color: #b0bcd4;
  transition: all 0.15s ease;
  padding: 0;
}

.check-btn:hover {
  border-color: #5E85EF;
  background: #eef1fa;
  color: #5E85EF;
}

.check-btn--active {
  background: #2D4B95;
  border-color: #2D4B95;
  color: #ffffff !important;
  box-shadow: 0 1px 4px rgba(45,75,149,0.3);
}

.check-btn--active:hover {
  background: #1e3573;
  border-color: #1e3573;
  color: #ffffff;
}

.check-btn--active .v-icon {
  color: #ffffff !important;
}

.check-btn:not(.check-btn--active) .v-icon {
  color: #cdd4e6 !important;
}

.check-btn:hover:not(.check-btn--active) .v-icon {
  color: #5E85EF !important;
}

/* ─── Vuetify overrides for revision text fields ─────── */
::v-deep .rev-text-field { margin: 4px !important; }
::v-deep .rev-date-field { margin: 0 !important; }

::v-deep .rev-text-field .v-input__control { min-height: 28px !important; }
::v-deep .rev-text-field .v-input__slot {
  min-height: 28px !important;
  background: #f7f8fc !important;
  border: 1px solid #d5dbed !important;
  border-radius: 5px !important;
  box-shadow: none !important;
  padding: 0 8px !important;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease !important;
}
::v-deep .rev-text-field:hover .v-input__slot {
  border-color: #5E85EF !important;
  background: #eef1fa !important;
}
::v-deep .rev-text-field.v-input--is-focused .v-input__slot {
  border-color: #5E85EF !important;
  background: #ffffff !important;
  box-shadow: 0 0 0 2px rgba(94,133,239,0.15) !important;
}
::v-deep .rev-text-field input {
  font-size: 12px !important;
  text-align: center !important;
  max-height: 28px !important;
  color: #18243d !important;
  caret-color: #5E85EF !important;
}
::v-deep .rev-text-field .v-text-field__slot { align-self: center; }

/* ─── Add revision button ─────────────────────────────── */
.add-revision-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  margin: auto;
  border: 1.5px solid #d0d8ed;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  color: #5E85EF;
  transition: all 0.15s ease;
  padding: 0;
}

.add-revision-btn:hover {
  background: #e8ecf5;
  border-color: #5E85EF;
}

.empty-cell {
  display: block;
  text-align: center;
  color: #d5dbed;
  font-size: 13px;
  line-height: 36px;
}

/* ─── Icon styles ─────────────────────────────────────── */
.v-icon {
  color: inherit !important;
  opacity: 0.8;
  transition: opacity 0.2s;
}
.v-icon:hover { opacity: 1; }
.group-header .v-icon,
.subgroup-header .v-icon { opacity: 1; }
</style>